<nav class="navbar navbar-expand-lg navbar-dark">
  <a class="navbar-brand" href="#">Shopping</a>

  <div class="collapse navbar-collapse">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/lists']">Lijsten</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/ingredients']">Ingrediënten</a>
      </li>
    </ul>
  </div>
</nav>
<router-outlet></router-outlet>
